<div class="banner">
  <div class="container">
    <div class="banner-content row align-items-center">
      <div class="text col-md-7 col-sm-12">
        <h1>we're excited to be here in <span>Midtown Atlanta.</span></h1>
        <p>now open across from the <span>Center MARTA station.</span> </p>
        <p>drop off your laundry and we'll take care of it with expert, professional care.</p>

        <form class="banner-form row" #f="ngForm" [formGroup]="notifyForm">
          <div class="email col-sm-6">
            <mat-form-field color="accent" dense appearance="fill">
              <mat-label>email address</mat-label>
              <input matInput formControlName="email" placeholder="email address">
              <mat-error *ngIf="f.form.controls['email']?.errors?.required">email is required</mat-error>
              <mat-error *ngIf="f.form.controls['email']?.errors?.email">email must be a valid email address</mat-error>
            </mat-form-field>
          </div>
          <div class="phone col-sm-6">
            <mat-form-field dense color="accent" appearance="fill" class="field-6 mat-country-selection">
                      <ngx-mat-intl-tel-input inputPlaceholder="phone number"
                       [preferredCountries]="['us','ae','in']"
                        [enablePlaceholder]="true" name="phone"
                         (countryChanged)="CountryChangedEvent($event)"
                        formControlName="phone" #phone></ngx-mat-intl-tel-input>
                      <mat-error *ngIf="f.form.controls['phone']?.errors?.required">phone is required</mat-error>
                      <mat-error *ngIf="f.form.controls['phone']?.errors?.validatePhoneNumber">invalid number</mat-error>
                    </mat-form-field>
          </div>

          <div class="col-sm-12 action-buttons">
            <button type="button" class="notify-btn" (click)="onNotify()">notify me</button>
            <button type="button" class="notify-btn view-pricing-btn">view pricing</button>
          </div>
        </form>
      </div>
      <div class="image col-md-5 col-sm-12">
        <img src="/assets/images/Icon__1-05.png" alt="Dryo icon">
      </div>
    </div>
  </div>
</div>
